import styled from 'styled-components'


export const DefaultButton = styled.button`
    border: 0;
    background: transparent;
`;